<template>
    <v-pagination v-bind="$attrs" class="rounded-0" @input="search"></v-pagination>
</template>

<script>
export default {
    props: {},
    components: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {
    search(page){
            this.$emit('input', page)
        }
    },
};
</script>

<style lang="scss" scoped></style>
